<template>
    <div class="p-fluid">
      <div class="p-col-12 p-lg-12">
        <div class="card card-w-title">
          <div class="manager-title-custom">{{title}}</div>
          <form id="frm_action">
            <div class="p-formgrid">
              <div class="">
                <div class="f-grid" style="margin: 0px 10px 0px 10px;">
                  <div class="f-grid-col">
                    <!-- <div class="mt-2" v-if="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN">
                    </div> -->
                    <div class="mt-2">
                      <label class="txt-right">Công ty</label>
                      <InputText disabled v-model="company.name" type="text" class="text-box input-text-box" placeholder="Nhập"/>
                    </div>
                    <div class="mt-2">
                      <label class="txt-right">Mã gói công việc</label>
                      <InputText disabled v-model="sra_code" type="text" class="text-box input-text-box" placeholder="Nhập"/>
                    </div>
                    <div class="mt-2">
                      <label class="txt-right">Gói công việc</label>
                      <InputText disabled v-model="sra_name" type="text" class="text-box input-text-box" placeholder="Nhập"/>
                    </div>
                    <div class="mt-2">
                      <label class="txt-right">Nhà thầu</label>
                      <InputText disabled v-model="contractor_txt" type="text" class="text-box input-text-box" placeholder="Nhập"/>
                    </div>
                    <div class="mt-2">
                      <label class="txt-right">Thời gian thực hiện từ</label>
                      <Calendar disabled v-model="date_start_1" dateFormat="dd/mm/yy" :showIcon="true" :manualInput="false" :showButtonBar="true" class="text-box input-text-box"/>
                    </div>
                    <div class="mt-2">
                      <label class="txt-right">Thời gian thực hiện đến</label>
                      <Calendar disabled v-model="date_end_1" dateFormat="dd/mm/yy" :showIcon="true" :manualInput="false" :showButtonBar="true" class="text-box input-text-box"/>
                    </div>
                    <div class="mt-2" style="padding-top: 5px;">
                      <label class="txt-right">ĐÁNH GIÁ NHÀ THẦU</label>
                    </div>
                    <div class="mt-2">
                      <label class="txt-right required">An toàn</label>
                      <div class="btn-group-css text-box input-text-box">
                        <button type="button" :class="['btn-switch', {selected : safe_value == 1}]" @click="changeAnToan(1)">Rất tệ</button>
                        <button type="button" :class="['btn-switch', {selected : safe_value == 2}]" @click="changeAnToan(2)">Tệ</button>
                        <button type="button" :class="['btn-switch', {selected : safe_value == 3}]" @click="changeAnToan(3)">Hoàn thành</button>
                        <button type="button" :class="['btn-switch', {selected : safe_value == 4}]" @click="changeAnToan(4)">Tốt</button>
                        <button type="button" :class="['btn-switch', {selected : safe_value == 5}]" @click="changeAnToan(5)">Rất tốt</button>
                      </div>
                    </div>
                    <div class="mt-2">
                      <label class="txt-right required">Chất lượng dịch vụ</label>
                      <div class="btn-group-css text-box input-text-box">
                        <button type="button" :class="['btn-switch', {selected : quality_value == 1}]" @click="changeChatLuongDichVu(1)">Rất tệ</button>
                        <button type="button" :class="['btn-switch', {selected : quality_value == 2}]" @click="changeChatLuongDichVu(2)">Tệ</button>
                        <button type="button" :class="['btn-switch', {selected : quality_value == 3}]" @click="changeChatLuongDichVu(3)">Hoàn thành</button>
                        <button type="button" :class="['btn-switch', {selected : quality_value == 4}]" @click="changeChatLuongDichVu(4)">Tốt</button>
                        <button type="button" :class="['btn-switch', {selected : quality_value == 5}]" @click="changeChatLuongDichVu(5)">Rất tốt</button>
                      </div>
                    </div>
                    <div class="mt-2">
                      <label class="txt-right required">Tiếp tục sử dụng cho lần sau</label>
                      <div class="btn-group-css text-box input-text-box">
                        <button type="button" :class="['btn-switch', {selected : continue_value == 1}]" @click="changeTiepTuc(1)">Không tiếp tục</button>
                        <button type="button" :class="['btn-switch', {selected : continue_value == 2}]" @click="changeTiepTuc(2)">Tiếp tục</button>
                      </div>
                    </div>
                    <div class="mt-2">
                      <label class="txt-right">Ghi chú</label>
                      <Textarea
                       v-model="note" 
                       :autoResize="true" rows="2" maxlength="14000" 
                       class="text-box input-text-box" 
                       placeholder="Nhập ghi chú"
                      />
                    </div>
                    <div class="mt-2">
                      <label class="txt-right">Xếp hạng</label>
                      <div class="btn-group-css text-box input-text-box">
                        <button type="button" :class="['btn-switch-1', {selected : badge == 'A'}]" @click="changeBadge('A')">A - Tốt</button>
                        <button type="button" :class="['btn-switch-2', {selected : badge == 'B'}]" @click="changeBadge('B')">B - Trung Bình</button>
                        <button type="button" :class="['btn-switch-3', {selected : badge == 'C'}]" @click="changeBadge('C')">C - Tệ</button>
                      </div>
                    </div>
                    <div class="mt-2" v-if="isOption1Company">
                      <div class="mt-3">
                        <label class="txt-right">Loại TNLĐ/Sự cố an toàn</label>
                        <DropdownScrollable
                          placeholder="Chọn"
                          :showClear="false"
                          cusClass="text-box m-0"
                          width="100%"
                          defaultLabel="label"
                          :multiple="false"
                          :limit="incidents_obj.limit"
                          :loading="incidents_obj.loading"
                          v-model="incidents_sel"
                          :options="incidents_obj.items"
                          :total="incidents_obj.total"
                          @keyup="emitEventIncidents"
                          @scroll="emitEventIncidents"
                          @offset="changeOffsetIncidents"
                        />
                      </div>
                      <div v-if="isOption1Company" class="mt-2">
                        <label v-for="(item, index) in incidents" :key="`incidents-${item.id}-${index}`" class="cus-tags">
                          <span class="cs-tag">
                            {{item.label}}
                          </span>
                          <i class="fas fa-times cs-icon" v-on:click="removeEvaluateItem('incidents', index)"></i>
                        </label>
                      </div>
                    </div>
                    <div class="mt-2" v-if="isOption1Company">
                      <div class="mt-3">
                        <label class="txt-right">Vi phạm an toàn</label>
                        <DropdownScrollable
                          placeholder="Chọn"
                          :showClear="false"
                          cusClass="text-box m-0"
                          width="100%"
                          defaultLabel="label"
                          :multiple="false"
                          :limit="violations_obj.limit"
                          :loading="violations_obj.loading"
                          v-model="violations_sel"
                          :options="violations_obj.items"
                          :total="violations_obj.total"
                          @keyup="emitEventViolations"
                          @scroll="emitEventViolations"
                          @offset="changeOffsetViolations"
                        />
                      </div>
                      <div class="mt-2">
                        <label v-for="(item, index) in violations" :key="`violations-${item.id}-${index}`" class="cus-tags">
                          <span class="cs-tag">
                            {{item.label}}
                          </span>
                          <i class="fas fa-times cs-icon" v-on:click="removeEvaluateItem('violations', index)"></i>
                        </label>
                      </div>
                    </div>
                    <div v-if="show_total_hour" class="mt-2">
                      <label class="txt-right">Số giờ làm việc</label>
                      <InputText v-model.number="sra_total_hour" type="number" min="0" class="text-box input-text-box" placeholder="Nhập số giờ làm việc"/>
                    </div>
                    <div class="mt-2">
                      <label class="txt-right">File đính kèm</label>
                      <div class="cus-text">Dung lượng tối đa: 50 MB</div>
                      <div class="cus-text">Định dạng file: docx, doc, xlsx, xls, pptx, pdf, png, jpg, jpeg.</div>
                      <input class="p-inputtext p-component text-box" multiple style="background-color: #EEEEEE;" accept=".docx, .doc, .xlsx, .xls, .pptx, .pdf, .png, .jpg, .jpeg" name="files[]" type="file" @change="onFileSelect"/>
                      <div class="box-images mt-3 text-box" v-if="files && files.length > 0">
                        <div class="d-flex align-items-center" v-for="(item, index) in files" :key="index">
                          <div class="file-name">{{ item.name }}</div>
                          <Button icon="pi pi-download" class="p-button-download p-button-link" @click="onFileDownload(index)"/>
                          <Button icon="pi pi-trash" class="p-button-secondary p-button-link text-danger" @click="onFileClear(index)"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Toolbar class="fixed-bottom-toolbar">
                <template slot="right">
                  <Button
                    :label="$constants.TEXT_BUTTON.BACK"
                    @click="backToList()"
                    class="p-button-warning return-style-button" />
                  <Button v-if="mode == 'evalute'"
                    :label="$constants.TEXT_BUTTON.ADD"
                    @click="saveData()"
                    class="p-button-success main-style-button" />
                  <Button v-else
                    label="Chỉnh sửa"
                    @click="saveDataEdit()"
                    class="p-button-success main-style-button" />
                </template>
              </Toolbar>
            </div>
          </form>
        </div>
      </div>
    </div>
</template>
<script>
import DropdownScrollable from '@/components/DropdownScrollable.vue';
import ApiRepository from "@/core/ApiRepository";
// import moment from "moment-timezone";
// import jq from 'jquery';
export default {
  components: {
    DropdownScrollable
  },
  data() {
    return {
        code : '',
        company : {id : '', name : ''},
        company_id : null,
        factory : null,
        extend_date_show : null,
        contractor_txt : '',
        expiration_data_date : null,
        view_id : null,
        model : {},
        name : '',
        sra_code : '',
        sra_name : '',
        sra_data_date : [],
        safe_value : null,
        quality_value : null,
        continue_value : null,
        badge : null,
        mode : 'evalute',
        title : 'Hoàn Thành & Đánh Giá Nhà Thầu',
        list_status : ['DONE','CLOSE_WAITTING','CLOSE_LV1','CLOSE'],
        note : '',
        sra_total_hour: 0,
        date_start_1 : null,
        date_end_1 : null,
        company_type : '',
        incidents: [],
        violations: [],
        incidents_sel: null,
        violations_sel: null,
        incidents_obj: {
          offset: 0,
          filters: {},
          limit: 20,
          items: [],
          total: 0,
          loading: false
        },
        violations_obj: {
          offset: 0,
          filters: {},
          limit: 20,
          items: [],
          total: 0,
          loading: false
        },
        show_total_hour: false,
        files: [],
        filesDeletes: [],
        maxFiles: 10,
        maxFileSize: 10485760 * 5,
    }
  },
  async mounted () {
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.company_id)){
        this.company_id = this.$route.query.company_id;
      }
    }
    if (this.$route.params.id !== undefined) {
        this.view_id = this.$route.params.id
        await this.getData(this.$route.params.id);
        if (this.model !== undefined && Object.keys(this.model).length > 0) {
            // if (this.list_status.includes(this.model.status)){
            //   this.mode = 'edit';
            // }
            console.log("this.model===",this.model)
            this.sra_code = this.model.code
            this.company = this.model.company
            this.company_id = this.model.company.id
            this.company_type =  this.model.company.company_type ?? ''
            this.factory = this.model.factory
            if(this.model.date_start && this.model.date_end){
              this.date_start_1 = new Date(this.model.date_start)
              this.date_end_1 = new Date(this.model.date_end)
              // this.data_date = [new Date(this.model.date_start), new Date(this.model.date_end)]
            }
            // this.extend_date_show = this.model.extend_date ? new Date(this.model.extend_date) : null
            
            var contractor_txt = '-'
            
            this.sra_name = this.model.name ?? ''
            
            if(this.model.contractor){
              contractor_txt = '['+this.model.contractor.code+'] '+this.model.contractor.name+''
            }
            this.contractor_txt = contractor_txt
            if(this.model.sra_date_start && this.model.sra_date_end){
              this.sra_data_date = [new Date(this.model.sra_date_start), new Date(this.model.sra_date_end)]
            }
            this.sra_total_hour = this.model.sra_total_hour ?? 0
            this.safe_value = this.model.sra_contractor_evaluate?.safe_value ?? null
            this.quality_value = this.model.sra_contractor_evaluate?.quality_value ?? null
            this.continue_value = this.model.sra_contractor_evaluate?.continue_value ?? null
            this.note = this.model.sra_contractor_evaluate?.note ?? ''
            this.badge = this.model.sra_contractor_evaluate?.badge ?? null
            this.incidents = (this.model.sra_contractor_evaluate_options ?? [])
              .filter(item => item.type === 'incidents')
              .map(item => this.mapEvaluateOption(item))
            this.violations = (this.model.sra_contractor_evaluate_options ?? [])
              .filter(item => item.type === 'violations')
              .map(item => this.mapEvaluateOption(item))
            this.files = (this.model.file_evaluate ?? []).map(item => ({
              ...item,
              type: 'old_edit'
            }))
            this.filesDeletes = []
            // if(this.model.expiration_start && this.model.expiration_end){
            //   this.expiration_data_date = [new Date(this.model.expiration_start), new Date(this.model.expiration_end)]
            // }
        }
        await this.getSraEvaluateOptions('incidents')
        await this.getSraEvaluateOptions('violations')
    }
  },
  watch : {
    "incidents_sel"() {
      this.appendEvaluateItem('incidents')
    },
    "violations_sel"() {
      this.appendEvaluateItem('violations')
    },
  },
  computed: {
    isOption1Company() {
      return true
      // return this.company_type === 'option_1'
    }
  },
  methods: {
    async saveData(){
      if(this.safe_value == null || this.quality_value == null || this.continue_value == null){
        alert('Vui lòng chọn các đánh giá nhà thầu')
        return
      }
      this.$commonFuction.is_loading(true);
      var param = {
        id: this.view_id,
        company_id: this.company_id,
        safe_value: this.safe_value,
        quality_value: this.quality_value,
        continue_value: this.continue_value,
        note: this.note,
        sra_total_hour: this.sra_total_hour,
        incidents: this.incidents.map(item => ({ id: item.id, total_count: item.total_count ?? 1 })),
        violations: this.violations.map(item => ({ id: item.id, total_count: item.total_count ?? 1 })),
        badge: this.badge,
      }
      var that = this;
      var files = this.files;
      var filesDeletes = this.filesDeletes;
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = { "Authorization": "Bearer "+token, };
        try {
          const response = await ApiRepository.post("/_api/sra/evaluate", param, {headers});
          if (response.status === 200) {
            if (filesDeletes.length > 0) {
              var object_delete = {
                type: that.$constants.TYPE_IMAGE.SRA_EVALUATE_CONTRACRTOR,
                ids: filesDeletes
              }
              await ApiRepository.post("/_api/common/delete-s3", object_delete, {headers})
            }
            if (files && files.length > 0) {
              await Promise.all(files.map(async file => {
                if (file.type !== 'old_edit') {
                  const resImage = await that.$CoreService.uploadImages(
                    that.$constants.FOLDER_S3.SRA_EVALUATE,
                    [file]
                  );

                  if (resImage) {
                    await that.$CoreService.updateDataImage(
                      that.$constants.TYPE_IMAGE.SRA_EVALUATE_CONTRACRTOR,
                      response.data.data?.id ?? that.view_id,
                      resImage[0]
                    );
                  }
                }
              }));
            }
            that.redirectEdit();
          } else {
            that.$toast.add({
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: response.data.message,
              life: 3000
            });
            that.$commonFuction.is_loading(false);
          }
        } catch (error) {
          console.log(error);
          that.$commonFuction.is_loading(false);
        }
      }else{
        this.$commonFuction.is_loading(false);
      }
    },
    async saveDataEdit(){
      await this.saveData()
    },
    async redirectEdit() {
      var router_back = {path: '/admin/list-sra/view/'+this.view_id, query: {company_id: this.company_id}};
      this.$commonFuction.is_loading(false);
      this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Lưu dữ liệu thành công', life: 3000 })
      this.$router.push(router_back);
    },
    changeAnToan(value){
      this.safe_value = value
    },
    changeChatLuongDichVu(value){
      this.quality_value = value
    },
    changeTiepTuc(value){
      this.continue_value = value
    },
    changeBadge(value){
      this.badge = value
    },
    mapEvaluateOption(item){
      if(!item){
        return {
          id: null,
          type: null,
          ordinal: null,
          total_count: 0,
          label: ''
        }
      }
      var label = item.label
      if(!label){
        label = item.name ?? ''
        if(item.total_count > 0){
          label += `(${item.total_count})`
        }
      }
      return {
        id: item.id,
        type: item.type,
        ordinal: item.ordinal,
        total_count: item.total_count ?? 0,
        label: label
      }
    },
    appendEvaluateItem(type){
      var sel = type === 'incidents' ? this.incidents_sel : this.violations_sel
      if(this.$commonFuction.isEmptyObject(sel)){
        return
      }
      var list = type === 'incidents' ? this.incidents : this.violations
      var existed = list.find(item => item.id == sel.id)
      if(!existed){
        list.push(this.mapEvaluateOption(sel))
      }
      if(type === 'incidents'){
        this.incidents_sel = null
      }else{
        this.violations_sel = null
      }
    },
    removeEvaluateItem(type, index){
      if(type === 'incidents'){
        this.incidents.splice(index, 1)
      }else{
        this.violations.splice(index, 1)
      }
    },
    async onFileDownload(index) {
      let file = this.files[index]
      window.open(file.url ?? file.objectURL)
    },
    async onFileSelect(event) {
      let files = event.target.files || event.dataTransfer.files
      if (files.length > 0) {
        if (files.length > this.maxFiles) {
          event.target.value = ""
          alert("Chỉ được upload tối đa 10 file")
          return
        }
        let acceptTags = [
          "docx", "doc", "xlsx", "pptx", "pdf", "xls",
          "DOCX", "DOC", "XLSX", "PPTX", "PDF", "XLS",
          "png", "jpg", "jpeg", "PNG", "JPG", "JPEG",
        ]
        for (let i = 0; i < files.length; i++) {
          if (!acceptTags.includes(files[i].name.split(".").pop())) {
            event.target.value = ""
            alert("Vui lòng upload file có định dạng là: docx, doc, xlsx, pptx, pdf, png, jpg, jpeg.")
            return
          }
        }
        if (files.length + this.files.length > this.maxFiles) {
          event.target.value = ""
          alert("Số lượng tối đa là " + this.maxFiles + " files")
          return
        } else {
          var arrTemp = [],
            arrFiles = []
          for (let file of files) {
            if (file.size <= this.maxFileSize) {
              file.source = file
              file.objectURL = window.URL.createObjectURL(file)
              arrTemp.push(file)
            } else {
              arrFiles.push(file)
            }
          }
          if (arrFiles.length > 0) {
            event.target.value = ""
            alert("File của bạn đã quá dung lượng 50MB")
            return
          } else {
            this.files = this.files.concat.apply(this.files, arrTemp)
          }
        }
      }
      event.target.value = ""
      return
    },
    onFileClear(index) {
      var file = this.files[index]
      if (file && file.type === 'old_edit' && file.id) {
        this.filesDeletes.push(file.id)
      }
      this.files.splice(index, 1)
    },
    emitEventIncidents(keyword){
      this.$delete(this.incidents_obj.filters, 'keyword')
      if (keyword) {
        this.incidents_obj.filters.keyword = keyword
      }
      this.getSraEvaluateOptions('incidents')
    },
    changeOffsetIncidents(value){
      this.incidents_obj.offset = value
    },
    emitEventViolations(keyword){
      this.$delete(this.violations_obj.filters, 'keyword')
      if (keyword) {
        this.violations_obj.filters.keyword = keyword
      }
      this.getSraEvaluateOptions('violations')
    },
    changeOffsetViolations(value){
      this.violations_obj.offset = value
    },
    async getSraEvaluateOptions(type) {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(!token){
        return
      }
      const headers = {
        "Authorization": "Bearer "+token,
      }
      var optionObj = type === 'incidents' ? this.incidents_obj : this.violations_obj
      optionObj.loading = true
      await ApiRepository.post("/_api/sra_evaluate/options", {
        filters: optionObj.filters,
        limit: optionObj.limit,
        offset: optionObj.offset,
        type: type,
        sra_id: this.$route.params.id ?? null
      }, {headers}).then((response) => {
        var list = (response.data.data?.sra_evaluate ?? []).map(item => this.mapEvaluateOption(item))
        if (optionObj.offset > 0) {
          optionObj.items.push(...list)
        } else {
          optionObj.items = list
        }
        optionObj.total = response.data.data?.count ?? 0
        optionObj.loading = false

        // Mặc định chọn sẵn những mục đã từng xuất hiện (total_count > 0)
        var targetList = type === 'incidents' ? this.incidents : this.violations
        list.forEach(opt => {
          if (opt.total_count > 0 && !targetList.find(sel => sel.id == opt.id)) {
            targetList.push(opt)
          }
        })
      }).catch(() => {
        optionObj.loading = false
      })
    },
    async getData(id) {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
        "Authorization": "Bearer "+token,
        };
        var {data} = await ApiRepository.post("/_api/sra/view_detail_evaluation", {id: id, company_id: this.company_id}, {headers});
        var value = data.data;
        this.model = value;
      }
    },
    backToList(){
      this.$router.push({path: '/admin/list-sra/view/'+this.view_id, query: {company_id: this.company_id}})
    }
  }

  
}
</script>
<style lang="scss">
  label {
    font-weight: bold;
  }
  .manager-title-custom{
    color: #1D3118;
    font-size: 18px;
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid #EEEEEE;
    font-weight: 700;
  }
  .p-inputnumber-buttons-stacked {
    .p-inputnumber-button-group {
      .p-button.p-button-icon-only { padding: 0 !important; }
    }
  }
  .note{ letter-spacing: 0px; color: #707070; margin-bottom: 24px; padding-top: 10px;}
  .p-formgrid { margin: 0;
    .p-panel-header {color: #000000; font-size: 18px; font-weight: bold; background: #EEEEEE;}
    .p-card-field{ padding: 24px;
      .p-field{
        .p-col-fixed { width: 300px; display: inline-block !important; margin: 0;}
        .p-col-width{width:500px !important; border-radius: 5px;
          &.disabled{background: #EEEEEE; border: 0 none; padding: 8px 10px;}
          .file-select{margin: 0;
            input[type="file"]{display: none;}
            .select-button{display: inline-block; cursor: pointer; background: transparent; border-radius: 5px;  color: #000000; font-size: 13px; padding: 3px 16px;  border: 1px solid #B4B4B4;}
          }
          &.pac-target-input{ height: 80px;  word-break: break-all; overflow-wrap: break-word;  resize: none;}
        }
        .box-images{ margin: 0; margin-top: 10px; position: relative;
          .item-img{width: 133px; height: 150px;  margin-right: 8px; margin-bottom: 8px; display: inline-flex; position: relative;
            img{max-width: 100%; height: auto;margin: 0 auto; object-fit: contain; padding: 5px;}
            .button-clear{border-radius: 5px; width: 24px; height: 24px; background: #F5564E; float: right; cursor: pointer; position: absolute; right: 0px;
              img{vertical-align: top;}
            }
          }
        }
        .p-invalid{display: block;}
      }
    }
    .fixed-bottom-toolbar{background: transparent; border: 0 none; margin-top: 22px; border-top: 1px solid #B4B4B4; padding: 0; padding-top: 30px;
      .p-button{width: auto; margin-right: 8px;
        &:last-child{margin-right: 0;}
      }
    }
  }
  .tab {
      display: flex;
      font-weight: 700;
      border-bottom: 1px solid #00000029;
  }
  .tab div {
      padding: 6px 8px;
      /* margin-right: 2px; */
      cursor: pointer;
  }
  .tab div.active {
      background-color: #fff;
      color: #0086C4;
      border-left: 1px solid #0086C4;
      border-right: 1px solid #0086C4;
      border-bottom: 3px solid #0086C4;
      border-top: 1px solid #0086C4;
  }
  .content {
      padding-top: 10px;
      display: none;
  }
  .content.active {
      display: block;
  }
  .button-container {
      display: flex;
      justify-content: flex-end; /* Căn chỉnh các nút về bên phải */
  }
  .button-container button {
      width: auto !important;
      margin-left: 5px; /* Khoảng cách giữa các nút */
  }
  .p-button-disa {
      color : #666666;
      background-color : #F2F3F7;
      border: 1px solid #F2F3F7;
  }
  .p-button-disa:hover {
      background-color: #F2F3F7 !important;
      border: 1px solid #F2F3F7 !important;
      color : #666666 !important;
  }
  .row-cs {
      padding-top : 6px;
  }
  .f-cus {
      color : #0086C4;
      font-weight: 700;
      font-size: 18px;
  }
  .title-css { 
    font-weight: bold;
  }
  .drop-cus {
    border: 1px solid #ccc;
    border-radius: 8px;
    padding: 10px;
  }
  .accordion-item {
    border: 1px solid #ddd;
    border-radius: 5px;
  }
  .accordion-label {
    display: block;
    padding: 8px;
    background-color: #DFE2E6;
    /* font-size: 15px; */
    font-weight: bold;
    cursor: pointer;
  }
  .accordion-content {
    margin-bottom: 5px;
  }
  .f-grid-v {
    display: flex;
    justify-content: space-between;
    flex-flow: row wrap;
    padding: 5px;
  }
  .f-grid-col-v {
    flex: 1 0;
    background-color: #F8F9FB;
    padding: 0px 10px 10px 10px;
    border-radius: 5px;
    margin: 5px 5px 5px 5px;
  }
  .left-cs {
      text-align: left;
      font-weight: bold;
      width: 120px;
      min-width: 120px;
  }
  .right-cs {
      text-align: right;
  }
  .left-cs-2 {
      text-align: left;
      font-weight: bold;
      width: 130px;
  }
  .container-tpl {
      display: flex; /* Sử dụng Flexbox để chia thành 2 phần */
      justify-content: space-between; /* Căn chỉnh nội dung sang hai bên */
      /* align-items: center; */
      padding-top : 5px;
  }
  .titel-cs {
      font-weight: bold;
  }
  .f-grid-col-v2 {
    background-color: #F8F9FB;
    padding: 0px 10px 5px 10px;
    border-radius: 5px;
    margin: 
    5px 10px 5px 10px;
  }
  .container-tpl-v2 {
    padding-top : 0px;
  }
  .btn-group-css {
    display: flex;
  }

  .btn-switch {
    width: 100px;
    padding: 8px;
    border: 1px solid #ccc;
    background-color: #fff;
    cursor: pointer;
    font-size: 1rem;
    transition: background-color 0.3s ease, color 0.3s ease;
    text-align: center; /* Căn giữa nội dung trong nút */
    white-space: nowrap; /* Ngăn chặn dòng văn bản bị gãy */
  }

  .btn-switch:hover {
    background-color: #aabcff;
  }

  .btn-switch.selected {
    background-color: #0086C4;
    color: white;
    /* font-weight: bold; */
  }
  .cus-text {
    color: #666666;
    font-size: 12px;
    margin-top: 4px;
  }
  .cus-tags{
    border-radius: 10px;
    padding: 8px;
    margin-right: 8px;
    background-color:#F2F3F7;
  }
  .cs-tag {
    padding: 10px 12px 10px 0px;
    font-weight: normal;
  }
  .cs-icon {
    color : #666666;
    padding-right: 4px;
    cursor: pointer;
  }

  .btn-switch-1 {
    width: 140px;
    padding: 8px;
    border: 1px solid #ccc;
    background-color: #fff;
    cursor: pointer;
    font-size: 1rem;
    transition: background-color 0.3s ease, color 0.3s ease;
    text-align: center; /* Căn giữa nội dung trong nút */
    white-space: nowrap; /* Ngăn chặn dòng văn bản bị gãy */
    font-size: 20px;
  }

  .btn-switch-1:hover {
    background-color: #aabcff;
  }

  .btn-switch-1.selected {
    background-color: green;
    color: white;
    /* font-weight: bold; */
  }
  .btn-switch-2 {
    width: 140px;
    padding: 8px;
    border: 1px solid #ccc;
    background-color: #fff;
    cursor: pointer;
    font-size: 1rem;
    transition: background-color 0.3s ease, color 0.3s ease;
    text-align: center; /* Căn giữa nội dung trong nút */
    white-space: nowrap; /* Ngăn chặn dòng văn bản bị gãy */
    font-size: 20px;
  }

  .btn-switch-2:hover {
    background-color: #aabcff;
  }

  .btn-switch-2.selected {
    background-color: orange;
    color: white;
    /* font-weight: bold; */
  }

  .btn-switch-3 {
    width: 140px;
    padding: 8px;
    border: 1px solid #ccc;
    background-color: #fff;
    cursor: pointer;
    font-size: 1rem;
    transition: background-color 0.3s ease, color 0.3s ease;
    text-align: center; /* Căn giữa nội dung trong nút */
    white-space: nowrap; /* Ngăn chặn dòng văn bản bị gãy */
    font-size: 20px;
  }

  .btn-switch-3:hover {
    background-color: #aabcff;
  }

  .btn-switch-3.selected {
    background-color: red;
    color: white;
    /* font-weight: bold; */
  }
</style>

